import { Prisma } from '@prisma/client';
import { TShareholderVsSharePercentageMap } from '../../EquityInfo/types';

export const validateEquityInfo = (
  shareholdersVsPercentageMap: TShareholderVsSharePercentageMap,
  shareCount: number,
  sharePrice: number
) => {
  if (!shareCount) {
    return {
      message: 'Please add no. of shares.',
    };
  }

  if (!sharePrice) {
    return {
      message: 'Please add per share price.',
    };
  }

  const companyValuation = sharePrice * shareCount;
  if (companyValuation < 1) {
    return {
      message: 'Company valuation is not valid.',
    };
  }

  if (!shareholdersVsPercentageMap) {
    return {
      message: 'Please add at least one shareholder.',
    };
  }

  if (shareCount < Object.keys(shareholdersVsPercentageMap).length) {
    return {
      message:
        'Number of shares cannot be less than the number of shareholders added.',
    };
  }

  const totalSharePercentage = Object.values(
    shareholdersVsPercentageMap
  ).reduce(
    (acc, curr) => acc.add(new Prisma.Decimal(curr.sharePercentage.toString())),
    new Prisma.Decimal(0)
  );

  if (!totalSharePercentage.eq(new Prisma.Decimal(100))) {
    return {
      message: 'Total share percentage should be 100.',
    };
  }

  const totalSharesCountByShareholders = Object.keys(
    shareholdersVsPercentageMap
  ).reduce((total, curr) => {
    return (
      total +
      Math.round(
        // We are not using the shareCount here beacause it get's updated after the form is submitted. To get the realtime share count we calculate using the percentage.
        (shareholdersVsPercentageMap[curr].sharePercentage * shareCount) / 100
      )
    );
  }, 0);

  if (totalSharesCountByShareholders !== shareCount) {
    return {
      message:
        'Based on the current equity split, partial shares are getting created which is not allowed. Please adjust the equity split to ensure the total number of shares is correctly distributed.',
    };
  }

  let totalPercentage = new Prisma.Decimal(0);

  for (
    let idx = 0;
    idx < Object.keys(shareholdersVsPercentageMap).length;
    idx += 1
  ) {
    const dsp =
      shareholdersVsPercentageMap[
        Object.keys(shareholdersVsPercentageMap)[idx]
      ];

    if (!dsp.sharePercentage && dsp.sharePercentage !== 0) {
      return {
        message: `Please fill share percentage for the shareholder ${dsp.name}`,
      };
    }

    totalPercentage = totalPercentage.add(
      new Prisma.Decimal(dsp.sharePercentage.toString())
    );
  }

  if (totalPercentage.lessThan(new Prisma.Decimal(100))) {
    return {
      message: 'Equity split should be equal to 100.',
    };
  }

  if (totalPercentage.greaterThan(new Prisma.Decimal(100))) {
    return {
      message: 'Total Equity Split cannot exceed 100.',
    };
  }

  return null;
};
